import { databases, getDatabaseFromPath, } from "@ssf/play-common";
import { initializeApp } from "firebase/app";
import { child, connectDatabaseEmulator, equalTo, push as firebasePush, ref as firebaseRef, remove as firebaseRemove, set as firebaseSet, get, getDatabase, limitToLast, onDisconnect, onValue, orderByChild, query, serverTimestamp, startAt, } from "firebase/database";
// Firebase doesn't like to be imported from multiple different paths https://stackoverflow.com/questions/41880933/nodejs-firebase-error-rangeerror-maximum-call-stack-size-exceeded-failure
export { child, equalTo, get, onDisconnect, onValue, orderByChild, query, serverTimestamp, startAt, limitToLast, app, };
const projectId = process.env.PLAY_PROJECT_ID;
if (!projectId) {
    throw new Error("Missing `PLAY_PROJECT_ID` env variable");
}
const apps = Object.fromEntries(databases.map((database) => {
    const app = initializeApp({
        apiKey: process.env.PLAY_API_KEY,
        authDomain: `${projectId}.firebaseapp.com`,
        databaseURL: `https://${projectId}-${database}.europe-west1.firebasedatabase.app/`,
        projectId,
    }, database);
    return [
        database,
        {
            app,
            database: getDatabase(app),
        },
    ];
}));
const app = apps["default-rtdb"].app;
if (process.env.MODE === "local") {
    Object.values(apps).forEach(({ database }) => {
        connectDatabaseEmulator(database, "localhost", 8063);
    });
}
export const refFromDatabase = (database, ...path) => firebaseRef(apps[database].database, path.join("/"));
export const ref = (...path) => refFromDatabase(getDatabaseFromPath(path), ...path);
export const push = (...path) => (value) => firebasePush(ref(...path), value);
export const set = (...path) => (value) => firebaseSet(ref(...path), value);
export const remove = (...path) => firebaseRemove(ref(...path));
export const challengesRef = "challenges"; // ref(database, 'challenges');
export const gamesRef = "games"; // ref(database, 'games');
export const nodesRef = "nodes"; // ref(database, 'nodes');
export const roomsRef = "rooms"; // ref(database, 'rooms');
export const connectedRef = ".info/connected"; // ref(database, '.info/connected');
export const serverTimeOffsetRef = ".info/serverTimeOffset"; // ref(database, '.info/serverTimeOffset');
export const attendancesRef = "attendances";
export const userToPlayer = (user) => ({
    uid: user.uid,
    name: user.displayName ?? "",
});
//# sourceMappingURL=firebase.js.map